import _ from 'lodash';
import Promise from 'bluebird';
import request from 'superagent';
import Debug from 'debug';
import DelectoryError from './DelectoryError';
import DelectoryCache from './DelectoryCache';

const debug = Debug('delectable');
const IsBrowser = typeof window !== 'undefined';

let currentVersion;
let cache = new DelectoryCache();

class DelectoryResource {
  constructor(delectory) {
    this._delectory = delectory;
  }

  static createEndpoint(spec) {
    return function(payload) {
      let context = {
        spec: spec,
        payload: payload
      };
      console.warn("Creating request object...");
      return this.createRequestPayload(context)
        .bind(this)
        .then(this.checkCache)
        .then(this.makeRequest);
    };
  }

  createRequestPayload(context) {
    return new Promise((resolve, reject) => {
      context.requestPayload = {
        payload: context.payload
      };

      let { session_key, session_token } = this._delectory.getAuthCredentials();
      if(session_key && session_token) {
        context.requestPayload.session_key = session_key;
        context.requestPayload.session_token = session_token;
      }
      else if(context.spec.authRequired) {
        // No auth-credentials
        return reject(new Error('Authorization required.'));
      }
      this._delectory.signPayload(context.requestPayload);
      return resolve(context);
    });
  }

  checkCache(context) {
    return new Promise((resolve, reject) => {
      context.cacheKey = context.spec.cacheConfig && context.spec.cacheConfig.genKey && context.spec.cacheConfig.genKey(context.requestPayload);
      if(context.cacheKey && (!context.spec.cacheConfig.browserOnly || IsBrowser)) {
        context.cacheKey = context.spec.path + ':' + context.cacheKey;
        debug(`Cache Key: ${context.cacheKey}`);
        let cachedResponsePayload = cache.get(context.cacheKey);
        if(cachedResponsePayload) {
          debug(`Cache Hit: ${context.cacheKey}`);
          context.cachedResponsePayload = cachedResponsePayload;
        }
      }
      return resolve(context);
    });
  }

  makeRequest(context) {
    let requestUrl = this._delectory.baseUrl + context.spec.path;
    return new Promise((resolve, reject) => {
      if(context.cachedResponsePayload) {
        return resolve(context.cachedResponsePayload);
      }
      console.warn("Making request");
      return request.post(requestUrl)
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json')
        .send(context.requestPayload)
        .end((err, res) => {
          console.warn("Done with makeRequest");
          if(err) {console.log("Error: ", err);}
          let rawErr;
          if(err || !res || !res.body) {rawErr = new Error('Cannot reach server');}
          else if(!res.body.success) {
            if (typeof res.body.error === 'string') {
              rawErr = new Error(res.body.error);
            } else {
              rawErr = res.body.error;
            }
          }

          if(rawErr) {
            rawErr.request_url = requestUrl;
            rawErr.request_payload = context.requestPayload;
            rawErr.response_status = res ? res.status : null;
            rawErr.response_body = res ? res.body : null;
            return reject(new DelectoryError(rawErr));
          }

          let delectoryVersion = res.header['delectory-version'];
          if(delectoryVersion) {
            if(!currentVersion) {
              currentVersion = delectoryVersion;
            } else if(delectoryVersion !== currentVersion && IsBrowser) {
              window.location.reload();
            }
          }
          if(context.cacheKey) {
            cache.put(context.cacheKey, _.cloneDeep(res.body.payload), context.spec.cacheConfig.ttl || 0);
          }
          return resolve(res.body.payload);
        });
    });
  }
}

export default DelectoryResource;



// WEBPACK FOOTER //
// banquet/lib/DelectoryApi/lib/DelectoryResource.js